'use strict';

export default class Common {
  constructor() {
    this.handleNewsletterSubmission();
    this.accordionSeeMore();
    this.attachLearnMore();
    this.wrapTables();
  }

  handleNewsletterSubmission() {}

  accordionSeeMore() {
    $(".accordion").each(function () {
      if ($(this).find(" > .field--name-field-items > .field__item").length > 5) {
        let currentAccordion = $(this);
        currentAccordion.after(`
          <div class='flex justify-center mt-small'>
            <a class='button button-primary button-sm button-rounded read-more'>Read more</a>
          </div>
        `);
        let showingLimted = true;
        currentAccordion.next().find('.read-more').on('click', function(e) {
          if(showingLimted) {
            currentAccordion.find(" > .field--name-field-items > .field__item").slice(5).fadeIn();
            $(this).text('Read less');
          } else {
            $('html, body').scrollTop(currentAccordion.offset().top);
            currentAccordion.find(" > .field--name-field-items > .field__item").slice(5).fadeOut();
            $(this).text('Read more');
          }
          showingLimted = !showingLimted;
        });
      }
    })
  }

  attachLearnMore() {
    let blocks = $(".paragraph--type--highlight-item");

    blocks.each(function(k,v) {
      let block = $(v);
      let link = $(v).find(".node__title > a").attr("href");
      let learnMore = $("<a/>", { href: link, text: "Learn more", 'class': 'button button-primary button-rounded button-sm my-small' })
      $(v).find(".node__content").append(learnMore);
    })
  }

  wrapTables() {
    $('table.table').each(function () {
      const table = $(this);

      if (!table.parent().hasClass('table-wrapper')) {
        table.wrap('<div class="table-wrapper"></div>');
      }
    });
  }
}
